import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyResourcesModule } from '../resources';
import { SkyTextExpandComponent } from './text-expand.component';
import { SkyModalModule } from '../modal';
import { SkyTextExpandModalComponent } from './text-expand-modal.component';


export class SkyTextExpandModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyTextExpandComponent,
    SkyTextExpandModalComponent
  ],
  imports: [
    SkyResourcesModule,
    SkyModalModule,
    CommonModule
  ],
  exports: [
    SkyTextExpandComponent
  ],
  entryComponents: [
    SkyTextExpandModalComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
